"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.isCheckable = isCheckable;
/**
 * Whether an element (or its type) is a checkbox/radio, or not
 *
 * @param   {HTMLInputElement|string}   inputOrType
 * @returns {boolean}
 */

function isCheckable(inputOrType) {
  if (inputOrType instanceof window.HTMLInputElement) {
    inputOrType = inputOrType.type;
  }
  return inputOrType === 'checkbox' || inputOrType === 'radio';
}